module.exports = __webpack_public_path__ + "img/BF_Fleur.ad0dc21b.svg";